import { Suspense } from "react";
import AdminImageList from "../../components/admin/AdminImagesList.jsx"
import { Link } from "react-router-dom";

export default function ImageListPage() {
  return (
    <section className="m-8">
      <div className="flex flex-row w-full">
        <h1 className="w-1/2">List of Images</h1>
        <div className="w-1/2 text-end">
          <Link className="text-blue-500 underline hover:no-underline text-sm" to="/cocofantoelefanto/images/new">Upload New Image</Link>
        </div>
      </div>

      <div id="teams" className={`w-full pt-4'`}>
        <Suspense fallback={<p>Carregando...</p>}>
          <AdminImageList />
        </Suspense>
      </div>
    </section>
  )
}
